import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { TankIndicatorSkeleton } from 'app/agriculture/routes/Tanks/TankIndicator/TankIndicatorSkeleton';
import { Skeleton } from '@mui/material';

export function LevelMonitorContentSkeleton() {
    return (
        <ContentBox.Section>
            <SimpleGrid columns={3}>
                <TankIndicatorSkeleton />
                <StatDisplay
                    name="Remaining"
                    value={<Skeleton variant="text" width={80} />}
                    unit="L"
                />
                <StatDisplay name="Linked Device" value={<Skeleton variant="text" width={120} />} />
            </SimpleGrid>
        </ContentBox.Section>
    );
}
